import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { SignInPhonesSchema } from "../../../../services/user/user.schema";
import { yupResolver } from "@hookform/resolvers/yup";
import { CheckboxController, GvInputMaskController } from "../../../../components/Controllers";
import UsFlagIcon from "../../../../components/Icons/UsFlagIcon";
import { LoadingBackdrop } from "../../../../components";
import { useNavigate } from "react-router-dom";
import { PAGES_PATH } from "../../../../navigation/params";
import { useSelector } from "react-redux";
import { IRootState } from "../../../../state";
import { IToastMessageState } from "../../../../state/request";
import { Button } from "@mui/material";
import { MIXPANEL_EVENTS } from "../../../../config/mixPanelEvents";
import { userActivityLogger } from "../../../../utils/mixpanel";
import { useUserStore } from "../../../../hooks/redux-hooks/user-store/user.store";
import { useUserUpdate } from "../../../../services/user-update/user-update.service";
import { getLocationId } from "../../../../utils/location-id";

interface Props {
  isFromAddPhonePage?: boolean;
  handleSendOTP: (data: { phone: string }) => void;
}
const MobileForm = ({ isFromAddPhonePage = false, handleSendOTP }:Props) => {
  const navigate = useNavigate();
  const { error } = useSelector((state: IRootState) =>
   state.toastMessage as IToastMessageState);
  const { userUpdatePhone, loading: updateUserLoading } = useUserUpdate();
  const { profileUser } = useUserStore();

  const { setError, control, handleSubmit: handleSubmitPhone } = useForm({
    mode: "onSubmit",
    resolver: yupResolver(SignInPhonesSchema),
    defaultValues: {
      phone: "",
      enablePhoneLogin: false,
    },
  });

  useEffect(()=>{
    if (error) {
      setError("phone", { message: error?.[0]?.message });
    }
  }, [error]);

  const handlePhoneSubmit = (data: { phone: string, enablePhoneLogin?: boolean }) => {
    const joinedPhone = data.phone.replace(/-/g, "");

    if (!data.enablePhoneLogin && isFromAddPhonePage) {
      const isUserCreatedFromEzyvet = !!profileUser?.contact_id;

      if (isUserCreatedFromEzyvet) {
        // No navigation here: RedirectCompleteProfile moves the user on once
        // the refreshed profile in Redux is complete.
        userUpdatePhone(joinedPhone, getLocationId(profileUser?.location));

        return;
      }
      navigate(PAGES_PATH.PROFILE_COMPLETION, {
        state: {
          phone: joinedPhone,
        } });
      userActivityLogger(MIXPANEL_EVENTS.USER_SIGNUP_ADD_MOBILE_NUMBER,
        { signin_type: "mobile", user_type: "new_user", mobile_signin_enabled: false, mobile_number: data.phone });
    } else {
      handleSendOTP({ phone: joinedPhone });
    }
  };

  return (
    <>
      {updateUserLoading && <LoadingBackdrop />}
      <form onSubmit={handleSubmitPhone(handlePhoneSubmit)}>
        <div>
          <div className="text-[0.8rem] font-semibold">Mobile Number</div>
          <div className="flex gap-1">
            <div className="w-32 mt-[0.35rem]">
              <div className="text-gray-1 flex items-center justify-start
          bg-white border border-gray-3 h-[2.65rem] px-3 rounded gap-2">
                <UsFlagIcon /> +1
              </div>
            </div>
            <GvInputMaskController
              control={control}
              name="phone"
              label=""
              mask="999-999-9999"
              placeholder="Mobile Number"
              className="font-semibold"
            />
          </div>
          {isFromAddPhonePage &&
        <div style={{ display: "grid", gridTemplateColumns: "48px auto" }}>
          <CheckboxController
            control={control}
            label=""
            name="enablePhoneLogin"
          />
          <div className="mt-1.5">
            <span>
              Enable Phone number sign-in (We&apos;ll send you a 6-digit code)
            </span>
          </div>
        </div>}
        </div>
        <Button
          id="sendOtpButton"
          color="primary"
          type="submit"
          className="!capitalize !font-bold"
          fullWidth
          sx={{ mt: "2rem" }}>{isFromAddPhonePage ? "Continue" : "Send Verification Code"}</Button>
      </form>
    </>
  );
};

export default MobileForm;
